import React, { useEffect } from 'react';
import __t from "../../lib/traduzioni"
import { CODICIERRORIAJAX } from '../../lib/ajaxhelper';
import { AccediORegistrati } from '../preventivo/FormPagamenti';
import { Alert, Box, Link } from '@mui/material';
import { Login } from '@mui/icons-material';

const DefaultErrorComponent = ({error}) => {

    const erroreConosciuto = CODICIERRORIAJAX[error.message] ?? null

    //lista dei componenti per errori specifici. Le chiavi di questo oggetto sono uguali a quelle di CODICIERRORIAJAX
    const Comps = {
        UTENTEDIVERSO
    }

    //controllo che esista un componente specifico per il tipo di errore
    const Comp = erroreConosciuto !== null ? Comps[error.message] ?? _DefaultErrorComponent : _DefaultErrorComponent;

    return (
        <>
            <Comp {...{error, erroreConosciuto}} />            
        </>
    )
}

const _DefaultErrorComponent = ({error, erroreConosciuto}) => {

    const loginurl = spedizioniweb2.getLoginUrl({});

    return (
        <Alert 
            severity='error' 
            action={((error?.message ?? null) === 'UTENTENONLOGGATO') && (
                <Box>
                    <Link href={loginurl} title={`${__t("accedi")} ${__t("o")} ${__t("registrati")}`} >
                        <Login />                        
                    </Link>
                </Box>
            )}
        >
            {erroreConosciuto ?? __t('oopserror')}            
        </Alert>
    )
}

/**
 * 
 * Mostro questo component quando l'utente di wp e di keycloak non sono uguali
 */
const UTENTEDIVERSO = () => {
    //return ("la sessione di keycloak non è più valida, rieffettua l'accesso!")

    useEffect(()=>{
        location.reload()
    }, [])

    return "..."
}

export default DefaultErrorComponent;